import useRiducer from "./useRiducer";

export default useRiducer;
